import React from "react";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import AccountInfo from "./components/account-info";
import ProfilePreference from "./components/profile-preference";
import ProfileSecurity from "./components/profile-security";
import { ProfileSettingsOpenProp } from "types/common";
import { useSelector } from "react-redux";
import { RootState } from "features/store";

const ProfileSettings: React.FC<ProfileSettingsOpenProp> = ({ handleProfileSettingsOpen }) => {
    const [activeTab, setActiveTab] = React.useState("general");
    const [deleteAccountModal, setDeleteAccountModal] = React.useState<boolean>(false)
    const handleDeleteOpen = () => setDeleteAccountModal((cur: boolean) => !cur)
    const { user } = useSelector((state: RootState) => state.culineerAuth)

    const data = [
        {
            label: "General",
            value: "general",
            desc: <AccountInfo handleProfileSettingsOpen={handleProfileSettingsOpen} />,
        },
        {
            label: "Notifications",
            value: "preference",
            desc: <ProfilePreference handleProfileSettingsOpen={handleProfileSettingsOpen} />,
        },
        {
            label: "Settings",
            value: "settings",
            desc: <ProfileSecurity
                handleProfileSettingsOpen={handleProfileSettingsOpen}
                handleDeleteOpen={handleDeleteOpen}
                deleteAccountModal={deleteAccountModal}
            />,
        },
    ];

    return (
        <Tabs value={activeTab}>
            <TabsHeader
                className="rounded-none border-b-[2px] border-blue-gray-50 bg-transparent p-0"
                indicatorProps={{
                    className: "bg-transparent border-b-[3px] border-primary shadow-none rounded-none",
                  }}
            >
                {data.map(({ label, value }) => (
                    <Tab
                        key={value}
                        value={value}
                        onClick={() => setActiveTab(value)}
                        className={activeTab === value ? "text-gray-900 underline-primary" : ""}
                    >
                        {label}
                    </Tab>
                ))}
            </TabsHeader>
            <TabsBody>
                {data.map(({ value, desc }) => (
                    <TabPanel key={value} value={value}>
                        {desc}
                    </TabPanel>
                ))}
            </TabsBody>
        </Tabs>
    );
}

export default ProfileSettings